<template>
    <div class="dj-container">
        <div class="dj-title">{{ form.title }}</div>
        <div class="dj-time">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
        <div class="dj-content" v-html="form.appContent">
        </div>
    </div>
</template>

<script>
import {infoDangj} from "@/api/admin/dangj"
import {timestampToTime} from "@/utils/date";

export default {
    name: "dangjInfo",
    components: {
    },
    props:{
        dangjId:{
            type: String,
            default:null
        },
    },
    watch:{
        dangjId(newValue,oldValue){
            this.form = {}
            this.getDangjInfo()
        },
    },
    data() {
        return {
            form:{},  //数据
            timestampToTime,
        };
    },
    created() {},
    mounted() {
        this.getDangjInfo()
    },
    unmounted() {},
    computed: {},
    methods:{
        getDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    var text = JSON.parse(JSON.stringify(this.form.content))
                    text = text.replace(/<video/gi,"<video style='width:96% !important;height:30% !important;background:#333 !important;'")
                    text = text.replace(/<img/gi,"<img style='width: 96% !important;height:auto !important;vertical-align: middle !important;max-height:96%;margin:0 auto !important;'")
                    text = text.replace(/<p style="/gi,'<p style="text-indent: unset !important;')
                    this.form.appContent = text
                    this.$emit('change-mode',"detailSub");
                }else {
                    this.$message.error("操作失败")
                }
            })
        }
    },
};
</script>
<style scoped>
.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-title{
    height: 45px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #DDD;
}
.dj-time{
    height: 40px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    width: 96%;
    margin: auto;
    overflow-x: hidden;
}
</style>